import React, { FunctionComponent } from 'react';
import Header from '@/components/typography/Header';
import { IPrismicRichTextElement } from '@/pageGeneration/services/prismicApi/types';
import PrismicRichText from '@/components/design/PrismicRichText';
import styles from './StaticPageHeader.module.scss';

interface IProps {
  title: string;
  subtitle: IPrismicRichTextElement[];
}

const StaticPageHeader: FunctionComponent<IProps> = ({ title, subtitle }) => (
  <div className={styles.container}>
    <Header level={1} strong color="white" responsive className={styles.header1}>
      {title}
    </Header>
    <PrismicRichText className={styles.subtitle} items={subtitle} color="white" />
  </div>
);

export default StaticPageHeader;
